<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleAdd()" :disabled="isEdit" type="primary" v-hasPermi="['scp:scpScDifferenceRatio:add']">新增</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1600, extraHeight: 0 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.DIFFERENCE_RATE_COEFFICIENT_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="differenceRatioTitle" class="align-center">差异率范围(%)&nbsp;
            <a-popover>
              <template slot="content">
                <p>不含起始差异率，包含截止差异率</p>
              </template>
              <span><a-icon type="info-circle" /></span>
            </a-popover>
          </span>
          <span v-for="item in wList" :key="item" :slot="`${item}Title`">
            <i class="toRequired">*</i>{{ item }}
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpScDifferenceRatio:update']">编辑</a>
                <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpScDifferenceRatio:remove']" class="ml10">删除</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'inputNumberNew'">
                <span v-if="!isEdit || currentId !== record.id">{{ record['differenceRatioFrom'] }} ~ {{ record['differenceRatioTo'] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record['differenceRatioFrom']" :min="0" size="small" />
                <span v-if="isEdit && currentId === record.id">&nbsp;~&nbsp;</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record['differenceRatioTo']" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" :parser="value =>value.replace(/^\D*(\d*(?:\.\d{0,5})?).*$/g,'$1')" size="small" />
              </span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpScDifferenceRatioSave,
  apiScpScDifferenceRatioDelete,
  apiScpScDifferenceRatioList,
  apiScpScDifferenceRatioUpdate
} from '@/api/scp/safety-stock/difference-rate-coefficient'

export default {
  // eslint-disable-next-line
  name: 'Difference-rate-coefficient', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: "",
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 查询参数
      queryParams: {},
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          // title: '差异率范围',
          customTitle: '差异率范围(%)',
          dataIndex: 'differenceRatio',
          scopedSlots: { customRender: 'differenceRatio', title: "differenceRatioTitle" },
          align: 'center',
          width: 250,
          type: "inputNumberNew"
        },
        {
          // title: 'W1',
          customTitle: 'W1',
          dataIndex: 'quantity01',
          scopedSlots: { customRender: 'quantity01', title: "W1Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W2',
          customTitle: 'W2',
          dataIndex: 'quantity02',
          scopedSlots: { customRender: 'quantity02', title: "W2Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W3',
          customTitle: 'W3',
          dataIndex: 'quantity03',
          scopedSlots: { customRender: 'quantity03', title: "W3Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W4',
          customTitle: 'W4',
          dataIndex: 'quantity04',
          scopedSlots: { customRender: 'quantity04', title: "W4Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W5',
          customTitle: 'W5',
          dataIndex: 'quantity05',
          scopedSlots: { customRender: 'quantity05', title: "W5Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W6',
          customTitle: 'W6',
          dataIndex: 'quantity06',
          scopedSlots: { customRender: 'quantity06', title: "W6Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W7',
          customTitle: 'W7',
          dataIndex: 'quantity07',
          scopedSlots: { customRender: 'quantity07', title: "W7Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W8',
          customTitle: 'W8',
          dataIndex: 'quantity08',
          scopedSlots: { customRender: 'quantity08', title: "W8Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W9',
          customTitle: 'W9',
          dataIndex: 'quantity09',
          scopedSlots: { customRender: 'quantity09', title: "W9Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      wList: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8", "W9"]
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  mounted () {
    this.getTableList()
  },
  methods: {
    // 页面-列表数据
    getTableList () {
      apiScpScDifferenceRatioList(this.queryParams).then(res => {
          this.$refs.dataTable.myDataSource = res.data
      })
    },
    // 新增
    handleAdd () {
      const arr = JSON.parse(JSON.stringify(this.$refs.dataTable.myDataSource))
      const obj = {
        differenceRatioFrom: "",
        differenceRatioTo: "",
        quantity01: "",
        quantity02: "",
        quantity03: "",
        quantity04: "",
        quantity05: "",
        quantity06: "",
        quantity07: "",
        quantity08: "",
        quantity09: "",
        id: "add"
      }
      arr.unshift(obj)
      this.$refs.dataTable.myDataSource = arr
      this.isEdit = true;
      this.currentId = "add";
    },
    // 行删除
    handleDelete (row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `你确定要删除这行内容吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpScDifferenceRatioDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.getTableList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (record.quantity01 === "" ||
      record.quantity02 === "" ||
      record.quantity03 === "" ||
      record.quantity04 === "" ||
      record.quantity05 === "" ||
      record.quantity06 === "" ||
      record.quantity07 === "" ||
      record.quantity08 === "" ||
      record.quantity09 === "") {
        this.$message.error('必填项不能为空')
        return
      }
      const obj = JSON.parse(JSON.stringify(record))
      if (obj.id === "add") {
        delete obj.id
        apiScpScDifferenceRatioSave(obj).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.getTableList()
          } else {
            this.$message.error(response.msg)
          }
        })
      } else {
        apiScpScDifferenceRatioUpdate(obj).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.getTableList()
          } else {
            this.$message.error(response.msg)
          }
        })
      }
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.getTableList()
    }
  }
}
</script>

<style scoped lang="less">
.ant-input-number {
  width: 100px;
}
/deep/.ant-pagination{
  display: none;
}
</style>
